import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const PriceTypeEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});

  useEffect(() => {
    fetchOneRecord(data);
  }, [data]);

  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const getLineName = (lineId) => {
    if (lineId === 1) return "TMĐT";
    if (lineId === 4) return "Line thường";
    if (lineId === 11) return "Line XT";
    if (lineId === 12) return "Line chính ngạch";
    return "";
  }
  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/contacts/savePriceType`;
      if (model.levelId) requestApi = `/api/levels/savePriceType`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('#form_fee_editor .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.response.data);
    }

  };

  const handleDeletPriceType = (e) => {
    general.openConfirm(async () => {
      try {
        var modelData = {};
        var requestApi = `/api/contacts/deletePriceType/${model.id}`;
        if (model.levelId) requestApi = `/api/levels/deletePriceType/${model.id}`;
        const response = await axiosInstance.post(requestApi, modelData);

        if (!response.data.success) {
          toast.error(response.data.message);
          console.log(response.data);
          return;
        }
        console.log(response);
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };

  const fetchOneRecord = async (params) => {
    //document.querySelectorAll('form .error-msg').forEach((item) => { item.remove() });
    
    const isNumber = Number.isFinite(params.id);
    if (!isNumber) {
      params.id = 0;
    }
    try {
      var requestApi = `/api/contacts/getPriceType?id=${params.id}`;
      if (params.levelId) requestApi = `/api/levels/getPriceType?id=${params.id}`;
      const response = await axiosInstance.get(requestApi);

      var model = { ...response.data.data, no: params.no };
      if (!model.contactId) model.contactId = params.contactId;
      if (!model.levelId) model.levelId = params.levelId;
      if (!model.lineId) model.lineId = params.lineId;
      setModel(model);
      console.log(model);
      setIsLocked(response.data.data.locked);
      setShow(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };
  return (
    <Modal show={show} onHide={handleModalClose} size="md">
      <div className="">

        <form id="form_fee_editor" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{model.id && <span>Cập nhật bảng giá: {getLineName(model.lineId)}</span>}{!model.id && <span>Thêm bảng giá: {getLineName(model.lineId)}</span>}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <label className="form-label d-none d-md-block">&nbsp;</label>
                      <div className="form-control item-no">
                        <b>#{model.no}</b>
                      </div>
                    </div>
                    <div className="col-11">
                      <label className="form-label" data-note={model.type}><span className="required">Tên bảng giá</span></label>
                      <div className="mb-3">
                        <input type="text" className="form-control" data-required="Phải nhập mục này" placeholder={model.type} disabled={model.locked} value={model.name ?? ''} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                      </div>

                      <label className="form-label" data-note={model.type}><span>Chi tiết</span></label>
                      <div className="">
                        <input type="text" className="form-control" placeholder="Chi tiết" disabled={model.locked} value={model.note ?? ''} onChange={(e) => setModel({ ...model, note: e.target.value })} />
                      </div>
                    </div>

                  </div>
                </div>

              </div>



            </div>
            <div className="modal-footer justify-content-between">
              <div>
                <button type="button" className="btn-small" onClick={() => handleDeletPriceType() }  >Xóa</button>

              </div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu bảng giá</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default PriceTypeEditor;
